import { Component } from '@angular/core';
import { AuthService } from '../../services/auth.service';

@Component({ standalone: false,
  selector: 'vfa-cp-login-error',
  templateUrl: './login-error.component.html',
  styleUrls: ['./login-error.component.scss'],
})
export class LoginErrorComponent {
  constructor(public authService: AuthService) {}
}

